
import { Vue, Component, Ref, Watch, Prop } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';

@Component
export default class VehicleSourceInformationField extends Vue {
  @Ref()
  childFormRef!: FormModel;

  formModel: any = {
    exteriorInfo: undefined,
    interiorInfo: undefined,
    accidentInfo: undefined,
  };

  exteriorInfoOptions: any[] = [];

  interiorInfoOptions: any[] = [];

  accidentInfoOptions: any[] = [];

  getLabel(arr: any, val: any) {
    let _text = '';
    arr.forEach((res: any) => {
      if (res.value === val) {
        _text = res.label;
      }
    });
    return _text;
  }

  @Prop()
  value!: any;

  @Prop()
  readonly!: boolean;

  @Watch('formModel.exteriorInfo')
  exteriorInfo() {
    this.handleFormModelChange();
  }

  @Watch('formModel.interiorInfo')
  interiorInfo() {
    this.handleFormModelChange();
  }

  @Watch('formModel.accidentInfo')
  accidentInfo() {
    this.handleFormModelChange();
  }

  handleFormModelChange() {
    this.$emit('update', this.formModel);
  }

  @Watch('value')
  handleValueChange() {
    const { exteriorInfo, interiorInfo, accidentInfo } = this.value;
    this.formModel = {
      exteriorInfo: exteriorInfo != null ? Number(exteriorInfo) : undefined,
      interiorInfo: interiorInfo != null ? Number(interiorInfo) : undefined,
      accidentInfo: accidentInfo != null ? Number(accidentInfo) : undefined,
    };
  }

  rules = {
    exteriorInfo: [{ required: true, message: '请选择外观成色' }],
    interiorInfo: [{ required: true, message: '请选择内饰状况' }],
    accidentInfo: [{ required: true, message: '请选择车辆状况' }],
  };

  public async validateFields(): Promise<boolean> {
    try {
      const valid = await (this.childFormRef as any).validate();
      return valid;
    } catch (error) {
      // console.error('子表单校验失败:', error);
      return false;
    }
  }

  breakDown(val: any) {
    const _a: any = [];
    Object.keys(val).forEach((key) => {
      _a.push({
        value: Number(key),
        label: val[key],
      });
    });
    return _a;
  }

  mounted() {
    this.handleValueChange();
    const carFields = JSON.parse(localStorage.getItem('carFields') || '{}');
    const { exterior_info, interior_info, accident_info } = carFields;
    this.exteriorInfoOptions = this.breakDown(exterior_info);
    this.interiorInfoOptions = this.breakDown(interior_info);
    this.accidentInfoOptions = this.breakDown(accident_info);
  }
}
